import { GetCatalogResource, GetCatalogResourceData, GetProductModelResource } from "../generated-api";
import ApiClient from "../nesterenko";

export class ApiCatalog {
  static async getCatalog(): Promise<GetCatalogResourceData[]> {
    const data = await ApiClient.get<GetCatalogResource>(`/catalog`);
    return data.data;
  }

  static async getProduct(id: number): Promise<GetProductModelResource> {
    const data = await ApiClient.get<GetProductModelResource>(`/catalog/${id}`);

    return data;
  }
}
